import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsForSection() {
  const forYou = ['Amas de casa que necesitan generar $100-$300 extras por semana sin descuidar a sus hijos.', 'Mujeres recién llegadas a USA que buscan una forma honesta y rápida de ganar dólares.', 'Cualquier persona con un teléfono inteligente y ganas de trabajar desde su cochera o sala.', 'Emprendedoras que quieren dejar de depender de un sueldo mínimo y ser sus propias jefas.'];
  const notForYou = ['Personas que buscan dinero "mágico" sin mover una sola caja.', 'Gente que no está dispuesta a responder mensajes en Facebook Marketplace.', 'Quienes buscan un curso técnico de marketing digital (esto es comercio puro y real).'];
  return <section className="w-full bg-amber-50 py-16 md:py-24 text-slate-900" data-id="element-185">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-186">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-187">
          {/* For You Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-188">
            <h3 className="text-2xl font-bold mb-8 text-green-700 flex items-center gap-2" data-id="element-189">
              <CheckCircle2 className="w-8 h-8" data-id="element-190" />
              Para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-191">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm border border-green-100" data-id="element-192">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-193" />
                  <span className="text-slate-800" data-id="element-194">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-195">
            <h3 className="text-2xl font-bold mb-8 text-red-700 flex items-center gap-2" data-id="element-196">
              <XCircle className="w-8 h-8" data-id="element-197" />
              NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-198">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm border border-red-100" data-id="element-199">
                  <XCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" data-id="element-200" />
                  <span className="text-slate-800" data-id="element-201">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}